import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AngularEditorConfig} from "@kolkov/angular-editor";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {ReplaySubject} from "rxjs";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {first, take, takeUntil} from "rxjs/operators";
import {MailingService} from "../../../shared/services/mailing.service";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {AuthService} from "../../../shared/services/auth.service";
import {el} from "@fullcalendar/core/internal-common";
import {Profile} from "../../../shared/interface/profile";
import {PARTNER_STATUS_INACTIVE} from "../../../shared/services/dict.service";
import {COMMA, SPACE, TAB, ENTER, SEMICOLON} from "@angular/cdk/keycodes";

@Component({
  selector: 'app-email-send-add',
  templateUrl: './email-send-add.component.html',
  styleUrls: ['./email-send-add.component.scss']
})
export class EmailSendAddComponent implements OnInit, OnDestroy {
  @Input() maxSize = 5 * 1024 * 1024;

  readonly PARTNER_STATUS_INACTIVE = PARTNER_STATUS_INACTIVE;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '400px',
    minHeight: '400px',
    maxHeight: '400px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Wprowadź treść ...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [],
      ['fontName', 'inline-block'],
      [
        'insertVideo',
        'insertImage',
        'insertHorizontalRule'
      ]
    ]
  };

  emailForm: FormGroup;
  dwControl: FormControl;
  toControl: FormControl;
  udwControl: FormControl;
  titleControl: FormControl;
  registrationControl: FormControl;
  registrationListControl: FormControl;
  registrationOfwcaControl: FormControl;
  registrationListOfwcaControl: FormControl;
  iddTrainingStatusControl: FormControl;
  partnerControl: FormControl;
  statusPartnerControl: FormControl;
  ofwcaControl: FormControl;
  basicEmailControl: FormControl;
  productEmailControl: FormControl;
  contestEmailControl: FormControl;
  billingEmailControl: FormControl;
  basicEmailOfwcaControl: FormControl;
  productEmailOfwcaControl: FormControl;
  contestEmailOfwcaControl: FormControl;
  contentControl: FormControl;
  fileControl: FormControl;
  contentAttachmentControl: FormControl;
  filterByRegionalControl: FormControl;
  regionalControl: FormControl;
  tagPartnerControl: FormControl;
  tagPartnerOfwcaControl: FormControl;
  employeeASF24Control: FormControl;
  userASF360Control: FormControl;
  contractTypeControl: FormControl;
  contractStatusControl: FormControl;
  contractTypeOfwcaControl: FormControl;
  contractStatusOfwcaControl: FormControl;
  departmentListControl: FormControl;
  profile?: Profile;
  processingRequest = false;
  separatorKeys: number[] = [ENTER, SPACE];


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private mailingService: MailingService,
    private auth: AuthService,
  ) {
    this.emailForm = fb.group({
      dw:  this.dwControl = this.fb.control([]),
      udw: this.udwControl = this.fb.control([]),
      title: this.titleControl = this.fb.control(''),
      registration: this.registrationControl = this.fb.control(false),
      registrationList: this.registrationListControl = this.fb.control([]),
      registrationOfwca: this.registrationOfwcaControl = this.fb.control(false),
      registrationListOfwca: this.registrationListOfwcaControl = this.fb.control([]),
      iddTrainingStatus: this.iddTrainingStatusControl = this.fb.control(''),
      filterByRegional: this.filterByRegionalControl = this.fb.control(false),
      regional: this.regionalControl = this.fb.control([]),
      tagPartner: this.tagPartnerControl = this.fb.control(''),
      tagPartnerOfwca: this.tagPartnerOfwcaControl = this.fb.control(''),
      statusPartner: this.statusPartnerControl = this.fb.control(''),
      partner: this.partnerControl = this.fb.control(false),
      ofwca: this.ofwcaControl = this.fb.control(false),
      basicEmail: this.basicEmailControl = this.fb.control(false),
      productEmail: this.productEmailControl = this.fb.control(false),
      contestEmail: this.contestEmailControl = this.fb.control(false),
      billingEmail: this.billingEmailControl = this.fb.control(false),
      basicEmailOfwca: this.basicEmailOfwcaControl = this.fb.control(false),
      productEmailOfwca: this.productEmailOfwcaControl = this.fb.control(false),
      contestEmailOfwca: this.contestEmailOfwcaControl = this.fb.control(false),
      content: this.contentControl = this.fb.control(''),
      file: this.fileControl = fb.control(''),
      filenameAttachment: fb.control(''),
      contentAttachment: this.contentAttachmentControl = fb.control(''),
      employeeASF24: this.employeeASF24Control = this.fb.control(false),
      userASF360: this.userASF360Control = this.fb.control(false),
      departmentList: this.departmentListControl = this.fb.control([]),
      contractType: this.contractTypeControl = this.fb.control(''),
      contractStatus: this.contractStatusControl = this.fb.control(''),
      toEmails:  this.toControl = this.fb.control([]),
      contractTypeOfwca: this.contractTypeOfwcaControl = this.fb.control([]),
      contractStatusOfwca: this.contractStatusOfwcaControl = this.fb.control([]),
    });
    this.basicEmailControl.disable();
    this.productEmailControl.disable();
    this.contestEmailControl.disable();
    this.billingEmailControl.disable();
    this.basicEmailOfwcaControl.disable();
    this.productEmailOfwcaControl.disable();
    this.contestEmailOfwcaControl.disable();
    this.statusPartnerControl.disable();
    this.iddTrainingStatusControl.disable();
    this.tagPartnerControl.disable();
    this.tagPartnerOfwcaControl.disable();
    this.contractTypeControl.disable();
    this.contractStatusControl.disable();
    this.departmentListControl.disable();
    this.regionalControl.disable();
    this.registrationListControl.disable();
    this.registrationListOfwcaControl.disable();
    this.auth.getProfile()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((profile: Profile) => {
        this.profile = profile;
      });
  }

  ngOnInit(): void {
    this.fileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((file: File[]) => {
        this.emailForm.get('contentAttachment').setValue('');
        this.emailForm.get('filenameAttachment').setValue('');

        if ( file) {
          file.forEach((fileToRead: File) => {
            this.emailForm.get('filenameAttachment').setValue(this.emailForm.get('filenameAttachment').value +
              (this.emailForm.get('filenameAttachment').value ? ', ' : '') +
              fileToRead.name);
            this.emailForm.get('contentAttachment').reset('');
            const reader = new FileReader();
            reader.readAsDataURL(fileToRead);
            reader.onload = () => {
              this.emailForm.get('contentAttachment').setValue(
                this.emailForm.get('contentAttachment').value +
                (this.emailForm.get('contentAttachment').value ? ', ' : '') +
                (/base64,(.+)/.exec(reader.result.toString())[1])
              );
            };
          });
        }
      });

    this.basicEmailControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (val) {
          this.productEmailControl.setValue(false);
          this.contestEmailControl.setValue(false);
          this.billingEmailControl.setValue(false);
        }
      });

    this.productEmailControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (val) {
          this.basicEmailControl.setValue(false);
          this.contestEmailControl.setValue(false);
          this.billingEmailControl.setValue(false);
        }
      });

    this.contestEmailControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (val) {
          this.basicEmailControl.setValue(false);
          this.productEmailControl.setValue(false);
          this.billingEmailControl.setValue(false);
        }
      });

    this.billingEmailControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (val) {
          this.basicEmailControl.setValue(false);
          this.productEmailControl.setValue(false);
          this.contestEmailControl.setValue(false);
        }
      });

    this.basicEmailOfwcaControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (val) {
          this.productEmailOfwcaControl.setValue(false);
          this.contestEmailOfwcaControl.setValue(false);
        }
      });

    this.productEmailOfwcaControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (val) {
          this.basicEmailOfwcaControl.setValue(false);
          this.contestEmailOfwcaControl.setValue(false);
        }
      });

    this.contestEmailOfwcaControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (val) {
          this.basicEmailOfwcaControl.setValue(false);
          this.productEmailOfwcaControl.setValue(false);
        }
      });

    this.ofwcaControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (!val) {
          this.tagPartnerOfwcaControl.reset();
          this.tagPartnerOfwcaControl.disable();
          this.iddTrainingStatusControl.reset();
          this.iddTrainingStatusControl.disable();
          this.basicEmailOfwcaControl.reset();
          this.basicEmailOfwcaControl.disable();
          this.productEmailOfwcaControl.reset();
          this.productEmailOfwcaControl.disable();
          this.contestEmailOfwcaControl.reset();
          this.contestEmailOfwcaControl.disable();
          this.registrationOfwcaControl.reset();
          this.registrationOfwcaControl.disable();
          this.registrationListOfwcaControl.reset();
          this.registrationListOfwcaControl.disable();
        } else{
          this.tagPartnerOfwcaControl.enable();
          this.iddTrainingStatusControl.enable();
          this.basicEmailOfwcaControl.enable();
          this.productEmailOfwcaControl.enable();
          this.contestEmailOfwcaControl.enable();
          this.registrationOfwcaControl.enable();
        }
      });

    this.partnerControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (!val) {
          this.contractTypeControl.reset();
          this.contractTypeControl.disable();
          this.contractStatusControl.reset();
          this.contractStatusControl.disable();
          this.statusPartnerControl.reset();
          this.statusPartnerControl.disable();
          this.basicEmailControl.reset();
          this.basicEmailControl.disable();
          this.billingEmailControl.reset();
          this.billingEmailControl.disable();
          this.productEmailControl.reset();
          this.productEmailControl.disable();
          this.contestEmailControl.reset();
          this.contestEmailControl.disable();
          this.tagPartnerControl.reset();
          this.tagPartnerControl.disable();
          this.registrationControl.reset();
          this.registrationControl.disable();
          this.registrationListControl.reset();
          this.registrationListControl.disable();
        } else {
          this.contractTypeControl.enable();
          this.statusPartnerControl.enable();
          this.basicEmailControl.enable();
          this.billingEmailControl.enable();
          this.productEmailControl.enable();
          this.contestEmailControl.enable();
          this.tagPartnerControl.enable();
          this.registrationControl.enable();
        }
      });

    this.contractTypeControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val) => {
        if (val){
          this.contractStatusControl.enable();
        } else {
          this.contractStatusControl.reset();
          this.contractStatusControl.disable();
        }
      });

    this.registrationControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (!val) {
          this.registrationListControl.reset();
          this.registrationListControl.disable();
        } else {
          this.registrationListControl.enable();
        }
      });

    this.registrationOfwcaControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (!val) {
          this.registrationListOfwcaControl.reset();
          this.registrationListOfwcaControl.disable();
        } else {
          this.registrationListOfwcaControl.enable();
        }
      });

    this.filterByRegionalControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (!val) {
          this.regionalControl.reset();
          this.regionalControl.disable();
        } else {
          this.regionalControl.enable();
        }
      });

    this.employeeASF24Control.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe((val: boolean) => {
        if (!val) {
          this.departmentListControl.reset();
          this.departmentListControl.disable();
        } else {
          this.departmentListControl.enable();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  cancel(): void {
    this.router.navigate(['/wysylka-maili']);
  }


  sendForm(): void {
    this.processingRequest = true;

    if (!this.partnerControl.value && !this.ofwcaControl.value
      && !this.employeeASF24Control.value && this.toControl.value.length === 0) {
      this.snack.open('Wybierz typ odbiorcy', '', {
        duration: 2000,
      });
      this.processingRequest = false;
      return;
    }
    if (this.partnerControl.value &&
      !this.productEmailControl.value &&
      !this.contestEmailControl.value &&
      !this.billingEmailControl.value &&
      !this.basicEmailControl.value ) {
      this.snack.open('Wybierz email dla Partnera', '', {
        duration: 2000,
      });
      this.processingRequest = false;
      return;
    }
    if (this.ofwcaControl.value &&
      !this.productEmailOfwcaControl.value &&
      !this.contestEmailOfwcaControl.value &&
      !this.basicEmailOfwcaControl.value ) {
      this.snack.open('Wybierz email dla OFWCA', '', {
        duration: 2000,
      });
      this.processingRequest = false;
      return;
    }
    if (!this.emailForm.valid) {
      this.emailForm.markAllAsTouched();
      this.snack.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      this.processingRequest = false;
      return;
    }

    this.contractTypeControl.setValue(this.contractTypeControl.value ? [this.contractTypeControl.value] : []);
    this.contractStatusControl.setValue(this.contractStatusControl.value ? [this.contractStatusControl.value] : []);
    this.iddTrainingStatusControl.setValue(this.iddTrainingStatusControl.value ? [this.iddTrainingStatusControl.value] : []);

    this.dwControl.setValue(this.dwControl.value.join(';'));
    this.udwControl.setValue(this.udwControl.value.join(';'));
    this.toControl.setValue(this.toControl.value.join(';'));

    this.mailingService.sendForm(this.emailForm.getRawValue())
      .pipe(
        take(1)
      )
      .subscribe((response: Uuid) => {
        this.snack.open('Pomyślnie wysłano', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.router.navigate(['/wysylka-maili']);
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas wysyłki wystąpił błąd', error.status?.toString(), {
          duration: 2000,
        });
      })
    ;
  }


  add(event: any, controlType: string): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      const delimiterRegex = /[\s,;]+/;

      if (delimiterRegex.test(value)) {
        const valuesToAdd = value.split(delimiterRegex).map((item: string) => item.trim()).filter((item: string) => item.length > 0);

        valuesToAdd.forEach((val: string) => {
          this.addValueToControl(controlType, val);
        });
      } else {
        this.addValueToControl(controlType, value.trim());
      }
    }

    if (input) {
      input.value = '';
    }
  }

  private addValueToControl(controlType: string, value: string): void {
    switch (controlType) {
      case 'dw':
        const dwValue = this.dwControl.value;
        this.dwControl.setValue([...dwValue, value]);
        break;
      case 'udw':
        const udwValue = this.udwControl.value;
        this.udwControl.setValue([...udwValue, value]);
        break;
      case 'to':
        const toValue = this.toControl.value;
        this.toControl.setValue([...toValue, value]);
        break;
      default:
        break;
    }
  }

  // Usuwanie chipsa z odpowiedniego kontrolera
  remove(index: number, controlType: string): void {
    if (controlType === 'dw') {
      const currentValue = this.dwControl.value;
      currentValue.splice(index, 1);
      this.dwControl.setValue([...currentValue]);
    } else if (controlType === 'udw') {
      const currentValue = this.udwControl.value;
      currentValue.splice(index, 1);
      this.udwControl.setValue([...currentValue]);
    } else if (controlType === 'to') {
      const currentValue = this.toControl.value;
      currentValue.splice(index, 1);
      this.toControl.setValue([...currentValue]);
    }
  }



}
